var GRID_SIZE = 8;
export var lineHeightToNumber = function lineHeightToNumber(height, size) {
  return height / (size * GRID_SIZE);
};